import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=9743f664&scoped=true&"
import script from "./PersonDetail.vue?vue&type=script&lang=js&"
export * from "./PersonDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetail.vue?vue&type=style&index=0&id=9743f664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9743f664",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/mgrunwald/Projects/Vue.js/playground/movie-app-dev/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBreadcrumbsItem } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VBtn,VCard,VContainer,VFlex,VIcon,VImg,VLayout,VProgressCircular,VSpacer,VSubheader,VTab,VTabItem,VTabs,VTabsSlider,VTooltip})
